<template>
  <div
    class="vhp-simple-slide"
  >
    <div class="vhp-slide-container" @scroll="onScroll">
      <div class="slide-item-wrap container-width">
        <div
          class="slide-item"
          v-for="(item, index) in filterdItems"
          :key="item.title"
          :class="index < slide + maxCount && index >= slide ? 'active' : ''"
          @click="onClickItem(item, index)"
          :style="[
            'left:' + ((index - slide) * 100) / maxCount + '% !important;',
            'width:calc(' + (getCardWidth() - 24) + 'px);',
          ]"
        >
          <div class="item-image">
            <img
              alt="card-image"
              :src="item.image"
              @error="replaceImage"
            />
          </div>

          <div class="item-content">
            <h1
              >{{ item.title }}
            </h1>
            <h4>
              {{item.subtitle}}
            </h4>
          </div>
        </div>
      </div>
    </div>

    <div class="vhp-buttons-container container-width">

      <div class="slide-button-wrap" v-if="isMoveable ">
        <div class="slide-sequence">
          <span
            v-for="n in items.length"
            :key="'sequence-' + n"
            :class="
              n - 1 <= slide + (maxCount - 1) && n - 1 >= slide ? 'active' : ''
            "
          >
          </span>
        </div>
      </div>

      
      <div class="slide-button-wrap" v-if="isMoveable">
        <div class="slide-button prev" @click="prev()">
          <span />
          <span />
        </div>
      </div>
      <div class="slide-button-wrap" v-if="isMoveable">
        <div class="slide-button next" @click="next()">
          <span />
          <span />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
    showCount: {
      type: Number,
      default: 1,
    },
    contain: {
      type: Boolean,
      default: false,
    },
    showTags: {
      type: Boolean,
      default: false,
    },
    showPrice: {
      type: Boolean,
      default: false,
    },
    showDate: {
      type: Boolean,
      default: false,
    },
    showSimple: {
      type: Boolean,
      default: false,
    },
    baseUrl: {
      type: String,
      default: "/",
    },
    listUrl: {
      type: String,
      default: "/",
    },
  },
  computed: {
    isMoveable() {
      return this.items.length > this.maxCount;
    },
    filterdItems() {
      // let items = this.items
      
      // items = items.slice(this.slide, (this.slide + this.maxCount))
      return this.items
    }
  },
  data() {
    return {
      slide: 0,
      maxCount: 1,
    };
  },
  mounted() {
    this.setMaxItemCount();
    window.addEventListener("resize", () => {
      this.setMaxItemCount();
    });


    setTimeout(() => {
      const items = document.getElementsByClassName('slide-item')
      for(let item of items) {
        item.style.transition = 'left .3s ease-in-out'
      }
    }, 300)
    
  },
  watch: {},
  methods: {
    setMaxItemCount() {
      this.maxCount =
        window.innerWidth < 640
          ? 1
          : window.innerWidth < 1024
          ? 2
          : this.showCount;
    },
    prev() {
      this.slide =
        this.slide > 0 ? this.slide - 1 : this.items.length - this.maxCount;
    },
    next() {
      this.slide =
        this.slide < this.items.length - this.maxCount ? this.slide + 1 : 0;
    },

    onScroll() {
      //const item = document.getElementsByClassName('item')[0]
    },

    onClickItem(item, index) {
      if (index < this.slide + this.maxCount && index >= this.slide) {
        if (item.externalUrl) {
          this.$utils.openLink(item.externalUrl);
        } else {
          this.$emit('click:item', item, index)
        }
      }
    },

    getCardWidth() {
      const container = document.getElementsByClassName('slide-item-wrap')[0]
      if(container) {
        const width = container.clientWidth
        return width / this.maxCount
      }
      return 0
    }
  },
};
</script>

<style lang="scss" scoped src="./vhpSlide.scss"></style>
